/** True for the three rules a Buy One Get One coupon can be configured with; NONE is not one. */
export function isBogoRule(rule) {
    return rule === 1 /* BogoSelectionType.LOWEST */
        || rule === 2 /* BogoSelectionType.SECOND_HIGHEST */
        || rule === 3 /* BogoSelectionType.HIGHEST */;
}
/**
 * The candidates in the order the rule would have them, best pick first. Sorted rather than
 * reduced so the caller can fall past a pick that does not work out; the sorts are stable, so
 * equally priced candidates keep the order they arrived in (the order the cart lists them).
 *
 * The rule "second highest" leads with the runner-up, then the rest of the way down, and the
 * dearest last — so a group with a single match, which has no second highest, still fills the
 * position on its own.
 */
export function orderByBogoRule(candidates, rule) {
    if (rule === 1 /* BogoSelectionType.LOWEST */)
        return [...candidates].sort((a, b) => a.price - b.price);
    const ranked = [...candidates].sort((a, b) => b.price - a.price);
    if (rule === 2 /* BogoSelectionType.SECOND_HIGHEST */ && ranked.length > 1)
        return [...ranked.slice(1), ranked[0]];
    return ranked;
}
//# sourceMappingURL=bogo-preference-order.js.map